/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input, NgZone} from '@angular/core';
import {handleCopyModalResult} from '../../common/util/handle-copy-modal-result';
import {ToastrService} from 'ngx-toastr';

import {AngularModalService} from '../../common/modal/angular-modal.service';
import {
  LayoutExampleToLayoutCopyModalComponent,
  LayoutExampleToLayoutCopyResult
} from './layout-example-to-layout-copy-modal.component';
import {StateService} from '@uirouter/core';

@Component({
  standalone: false,
  selector: 'adn-layout-example-context-actions',
  template: `
    <a *ngIf="!readOnly"
       class="btn btn-default btn-xs"
       (click)="copy()">
      <span class="fa fa-fw fa-copy"></span>Copy To A New Layout
    </a>
  `
})
export class LayoutExampleContextActionsComponent {
  @Input() model: any;
  @Input() readOnly: boolean;

  constructor(
    private readonly toastr: ToastrService,
    private readonly $state: StateService,
    private readonly angularModalService: AngularModalService,
    private readonly ngZone: NgZone
  ) {
  }

  copy(): void {
    if (this.readOnly || !this.model) {
      return;
    }

    const modalRef = this.angularModalService.show(LayoutExampleToLayoutCopyModalComponent, {
      initialState: {model: this.model}
    });
    (modalRef.content as LayoutExampleToLayoutCopyModalComponent).onCopied.subscribe(
      (result: LayoutExampleToLayoutCopyResult) => {
        handleCopyModalResult(() => {
          this.ngZone.run(() => {
            if (result.destination) {
              this.$state.go('app.adm.layouts.layout', {id: result.model.id}, {inherit: false});
            } else {
              this.toastr.success(
                'A new layout based on this example was successfully created.',
                'New Layout Created'
              );
            }
          });
        });
      }
    );
  }
}
